// extracted by mini-css-extract-plugin
export default {"activeTab":"Tab_activeTab__Bafb-","inactiveTab":"Tab_inactiveTab__d7KD4"};